import { UserProfile } from './UserProfile';

export class AuthContext {
    userProfile: UserProfile;


    get isClientAdmin(){

        const clientAdmin=this.userProfile.authorities.includes('ROLE_manage-users');
        return clientAdmin;
    }

    get isPMSadmin(){
        return !!this.userProfile.authorities!=null && !!this.userProfile.authorities.find(a=>a=='ROLE_manage-client');
    }
}
